<div [class.hidden]="!show">
  <div class="loader-overlay">
    <div class="card">
      <div class="card-body">
        <div style="float: left;">
          {{mensagem}}
        </div>
        <div style="float: right;">
          {{atual}}/{{total}}
        </div>
        <br />
        <div class="progress">
          <div id="barra-progresso" class="progress-bar progress-bar-striped progress-bar-animated"
            [ngStyle]="{'width': porcentagem }">
            {{porcentagem === '100%' ? '' : porcentagem}}
          </div>
        </div>
        <br />
        <button (click)="abortar()" class="btn btn-sm btn-danger float-right ml-5">
          Abortar
        </button>
      </div>
    </div>
  </div>
  <div class="capa-preta"></div>
</div>